import styled from 'styled-components';
import { Card, Typography } from 'antd';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.white};
  min-height: 100vh;
  overflow: auto;
  padding: 16px 24px;

  @media (max-width: 1024px) {
    padding: 12px;
  }
`;

export const FiltersCard = styled(Card)`
  margin-bottom: 16px;
  border-radius: 8px;

  .filter-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }
`;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 12px;
`;

export const KpiCard = styled.div`
  background: ${({ theme }) => theme['gray-100'] || '#f5f5f5'};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme['gray-200'] || '#f0f0f0'};
  padding: 14px;
  display: flex;
  flex-direction: column;
  min-height: 108px;

  .label {
    font-size: 12px;
    color: ${({ theme }) => theme['gray-600'] || '#666'};
    margin-bottom: 6px;
  }

  .sub {
    font-size: 11px;
    color: ${({ theme }) => theme['gray-500'] || '#888'};
    margin-top: 6px;
  }
`;

export const KpiValue = styled.span`
  font-size: 28px;
  line-height: 1;
  font-weight: 700;
  color: ${({ theme }) => theme['gray-900'] || '#111'};

  &.good {
    color: #3b6d11;
  }

  &.warn {
    color: #854f0b;
  }

  &.bad {
    color: #a32d2d;
  }
`;

export const SectionTitle = styled(Typography.Title)`
  margin-top: 18px !important;
  margin-bottom: 10px !important;
`;
